// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mQJM","left":"styles_left__3NE1P"};